import React from "react";

import { useIntl } from "../../../../../../shared/core/i18n/use-intl";
import { CARD_REFABRICATION_MODAL_ID } from "../../../../../core/modal/modal-id";
import { Modal } from "../../../../common/modal/modal";
import { StaticAssets } from "../../../../styles/custom-assets";
import { ActionMenu } from "../action-menu";
import { CardRefabricateModal } from "../card-refabricate-modal";
import type { ActivationCardProps } from "./activation-modal";

export const OrderNewCardButton: React.FC<ActivationCardProps> = ({ card, className }) => {
  const { formatMessage } = useIntl();

  return (
    <ActionMenu
      title={formatMessage("cardsList.orderCard")}
      iconSrc={StaticAssets.cardNew}
      className={className}
      onClick={() => {
        Modal.present(CARD_REFABRICATION_MODAL_ID, () => <CardRefabricateModal card={card} />, {
          canBeDismissed: false,
        });
      }}
    />
  );
};
